// @ts-expect-error untyped import
import { getAppContext } from '../selectors/app';
// @ts-expect-error untyped import
import { debug } from '../utils/env';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsEcosystemSocialScreenshotUserAgent } from 'marketplace-ui-common/js/utils/userAgent';
import * as AppContext from '../constants/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncFeedbackLoader = Loadable({
  loader: () =>
  // @ts-expect-error untyped module
  import( /* webpackChunkName: 'feedback-loader' */'feedback-loader')
});
const FEEDBACK_SURVEY_TYPE = 'CSAT';
const FEEDBACK_SURVEY_ID = 894;
const DEBUG_FEEDBACK_SURVEY_LOADER = debug('feedbackSurveyLoader');
export default function FeedbackSurveyLoader() {
  const appContext = useSelector(getAppContext);
  const [pollCount, setPollCount] = useState(0);
  const [hsFeedbackExists, setHsFeedbackExists] = useState(false);
  const feedbackDisabled = useMemo(() => {
    return window.disabledHsPopups && window.disabledHsPopups.includes('FEEDBACK') || getIsEcosystemSocialScreenshotUserAgent();
  }, []);
  useEffect(() => {
    if (window.hsFeedback) {
      setHsFeedbackExists(true);
    } else if (pollCount < 5 && !hsFeedbackExists) {
      setTimeout(() => {
        setPollCount(pollCount + 1);
      }, 1000);
    }
    if (DEBUG_FEEDBACK_SURVEY_LOADER && pollCount >= 5 && !hsFeedbackExists) {
      console.log('window.hsFeedback does not exist');
    }
  }, [hsFeedbackExists, pollCount]);
  useEffect(() => {
    if (appContext === AppContext.PUBLIC && hsFeedbackExists && !feedbackDisabled) {
      if (DEBUG_FEEDBACK_SURVEY_LOADER) {
        console.log('loading public feedback survey');
      }
      window.hsFeedback.loadSurvey(FEEDBACK_SURVEY_TYPE, FEEDBACK_SURVEY_ID);
    }
  }, [appContext, feedbackDisabled, hsFeedbackExists]);
  if (appContext === AppContext.IN_APP && !feedbackDisabled) {
    if (DEBUG_FEEDBACK_SURVEY_LOADER) {
      console.log('mounting in-app feedback loader');
    }
    return /*#__PURE__*/_jsx(AsyncFeedbackLoader, {
      onClientLoad: feedbackClient => {
        if (DEBUG_FEEDBACK_SURVEY_LOADER) {
          console.log('on client load firing');
        }
        return feedbackClient.loadSurvey(FEEDBACK_SURVEY_TYPE, FEEDBACK_SURVEY_ID);
      }
    });
  }
  return null;
}